module.exports = __webpack_public_path__ + "../resources/img/ic_rain_heavy_weather.88fe1f4f.svg";